import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { OktaCallbackComponent } from '@okta/okta-angular';

import { oktaAuthGuard } from './core/auth/guards/okta-auth.guard';
import { AuthSessionService } from './core/auth/services/auth-session.service';
import { Login } from './core/layout/login/login';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: Login,
  },
  {
    path: 'login',
    component: Login,
  },
  {
    path: 'login/callback',
    component: OktaCallbackComponent,
  },
  {
    path: '',
    canActivate: [oktaAuthGuard],
    loadComponent: () => import('./core/layout/main-layout/main-layout').then((c) => c.MainLayout),
    children: [
      {
        path: '',
        pathMatch: 'full',
        // Mirrors Header.primaryHomeRoute so the default landing page matches persona access.
        redirectTo: () =>
          inject(AuthSessionService).hasPersonaAccess('powerBi') ? 'dashboard' : 'action',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard-page/dashboard-page').then((c) => c.DashboardPage),
        canActivate: [oktaAuthGuard],
      },
      {
        path: 'action',
        loadComponent: () =>
          import('./features/actions/action-cockpit-page/action-cockpit-page').then(
            (c) => c.ActionCockpitPage,
          ),
        canActivate: [oktaAuthGuard],
      },
      {
        path: 'transaction-history-details',
        loadComponent: () =>
          import('./features/transaction-history/transaction-history-details/transaction-history-details').then(
            (c) => c.TransactionHistoryDetailsPage,
          ),
        canActivate: [oktaAuthGuard],
      },
      {
        path: 'export-insights',
        loadComponent: () =>
          import('./features/export-insights/export-insights-page/export-insights-page').then(
            (c) => c.ExportInsightsPage,
          ),
        canActivate: [oktaAuthGuard],
      },
      {
        path: 'create-form',
        loadComponent: () =>
          import('./features/create-form/create-form-master').then((c) => c.CreateFormMaster),
        canActivate: [oktaAuthGuard],
      },
    ],
  },
];
